import { MAX_REVIEW_STARS, RATING_STARS_VALUES } from '../constants/reviews';

export const productReviewsDataMapper = (review) => {
  const baseURL = process.env.SITE_URL || 'https://assetstore.unity.com';

  return {
    id: review.id,
    review: review.rating ?? 0,
    value: review.rating ?? 0,
    max: MAX_REVIEW_STARS,
    reviewerInfo: {
      name: review.userProfile?.name ?? '',
      link: `${baseURL}/users/${review.userProfile?.id || ''}`,
      avatarURL: review.userProfile?.image || '',
      username: review.userProfile?.username ?? '',
      image: review.userProfile?.image ?? '',
      email: review.userProfile?.primaryEmail ?? '',
    },
    reviewDetails: {
      id: review.id,
      stars: {
        value: review.rating ?? 0,
        max: MAX_REVIEW_STARS,
      },
      review: review.body,
      gifted: false,
      version: review.productMetadata?.upm?.packageVersion ?? '',
      title: review.title ?? '',
      text: review.body ?? '',
      rating: RATING_STARS_VALUES,
      helpfulCount: 0,
      publishedDate: review.createdAt,
      canReportReview: review.permissions?.canReport ?? false,
      canEdit: review.permissions?.canEdit ?? false,
      canDelete: review.permissions?.canDelete ?? false,
      canReply: false,
      canHelpfulVotes: review.permissions?.canMarkHelpful ?? false,
    },
  };
};
